import { render, staticRenderFns } from "./SupportDetails.vue?vue&type=template&id=39c1ce88&scoped=true"
var script = {}
import style0 from "./SupportDetails.vue?vue&type=style&index=0&id=39c1ce88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c1ce88",
  null
  
)

export default component.exports